module.exports = __webpack_public_path__ + "assets/img/客户案例-华西证券.dfe044c7.png";